export default "__VITE_ASSET__m_GiPBgv__"